import Image from "next/image";
import Link from "next/link";
import { useContext, useEffect, useRef, useState } from "react";
import playButton from "../../../../../shared-assets/icons/PlayButtonText.png";
import Imagic from "../../../../components/imagic/imagic";
import { Product } from "../../../../models/home-rows";
import AppContext from "../../../../services/app-context-services";
import { trackEvent } from "../../../../services/ga-services";
import { ROUTES } from "../../../../services/router-services";
import { ellipsis, _, _c } from "../../../../services/text-services";
import ImageSrc from "../../../shared/image-src/image-src";
// @ts-ignore
import styles from "./feature.module.scss";
interface ProductProps {
  productFeature: Product;
}

const LIMIT_LENGTH = 200;

function Feature({ productFeature }: ProductProps) {
  const {setShowLoginPopup} = useContext(AppContext);
  const [imgSrc, setImgSrc] = useState("");
  const [url, setUrl] = useState("");

  useEffect(() => {
    if (!productFeature?.id) return;
    setUrl(ROUTES.product(productFeature));
  }, [productFeature.id]);

  return imgSrc ? (
    <div
      className={_c(styles, `container d-flex justify-content-between feature`)}
      style={{
        backgroundImage: `linear-gradient(to right, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url("${imgSrc}")`,

        backgroundPosition: "center center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat"
      }}
    >
      <div
        className={`
            d-flex
            flex-column
            justify-content-space-around ${styles.info}
          `}
      >
        <div className={`${styles.title} title mb-4 mt-4`}>
          {_(productFeature?.name)} | {productFeature?.name_english}
        </div>
        {productFeature.approved_age && (
          <div
            className={`mb-4 d-flex justify-content-flex-start ${styles.age} desktop`}
          >
            <span className={`desktop pt-1`}>
              {productFeature.approved_age}+
            </span>
          </div>
        )}
        <div className={`mb-3 pr-0" ${styles.description}`}>
          <p className={`desktop`}>
            {ellipsis(_(productFeature?.short_description), LIMIT_LENGTH)}
          </p>
          <div
            className={`${styles.play_btn} mb-1 d-flex justify-content-flex-start`}
          >
            {productFeature?.id && (
              <Link prefetch={false} href={url}>
                <a
                  className="d-flex"
                  onClick={e => {
                    trackEvent(
                      "Home Item",
                      "Feature Row",
                      productFeature?.name ?? ""
                    );
                  }}
                >
                  <div className={styles.play}>
                    <Image
                      src={playButton}
                      alt="play"
                      width={150}
                      height={40}
                      //loader={simpleLoader}
                    />
                  </div>
                </a>
              </Link>
            )}
          </div>
        </div>
      </div>
      {productFeature?.id && (
        <Link prefetch={false} href={url}>
          <a
            className={styles.poster}
            onClick={e => {
              trackEvent(
                "Home Item",
                "Feature Row",
                productFeature?.name ?? ""
              );
            }}
          >
            {productFeature?.avatar?.xhdpi && (
              <Imagic
                src={productFeature.avatar.xhdpi}
                width={384}
                height={555}
                alt="product-feature"
                // layout="fill"
                //loader={simpleLoader}
              />
            )}
          </a>
        </Link>
      )}
    </div>
  ) : (
    <div className={_c(styles, `image-bg`)}>
      {productFeature?.feature_avatar?.xxhdpi && (
        <ImageSrc
          src={productFeature.feature_avatar.xxhdpi}
          height={768 / 5}
          width={1228 / 5}
          objectFit="cover"
          objectPosition="center"
          onNextSource={src => setImgSrc(src)}
        />
      )}
    </div>
  );
}

export default Feature;
